export default __webpack_public_path__ + "static/the-power-of-integration-with-tms-da7ca6058b651020740a3eed3ba78de4.jpg";